import React, { createContext, useState, useContext, useEffect } from 'react';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Create the language context
const LanguageContext = createContext();

// Translation resources
const resources = {
  nl: {
    translation: {
      // Home component
      "collaborate_create": "Laten we samenwerken en iets geweldigs creëren",
      "build_description": "Wij bouwen krachtige software waarmee bedrijven kunnen groeien, innoveren en voorop blijven lopen. Of het nu gaat om maatwerk applicaties, SaaS-platformen of AI-gedreven oplossingen, wij ontwikkelen technologie die efficiënt, modern en toekomstbestendig is.",
      "see_difference": "Zie hoe wij het verschil maken",
      "view_cases": "Bekijk Cases",

      // Header component
      "home": "HOME",
      "about": "OVER ONS",
      "services": "DIENSTEN",
      "contact": "CONTACT",
      "lets_call": "LATEN WE BELLEN",

      // Services component
      "read_more": "Lees meer",
      "our_services": "Onze Diensten",
      "services_subtitle": "Ontdek onze uitgebreide digitale diensten en oplossingen",
      "web_development": "Webontwikkeling",
      "web_development_content": "Onze webontwikkelingsdiensten omvatten het bouwen van websites vanaf de basis, het aanpassen van diverse CMS-systemen, het ontwikkelen van webapplicaties en het bieden van ondersteuning na oplevering. Wij werken altijd met de nieuwste technologieën om snelle, functierijke en aantrekkelijke websites te realiseren.",
      "software_app_development": "Software & App Ontwikkeling",
      "software_app_development_content": "Wij zijn gespecialiseerd in het ontwikkelen van maatwerk software en mobiele apps die bedrijven helpen om processen te stroomlijnen en hun doelgroep effectief te bereiken. Ons ontwikkelteam beheerst diverse programmeertalen en frameworks om robuuste en schaalbare applicaties te leveren.",
      "design_branding": "Design & Branding",
      "design_branding_content": "Onze design- en brandingdiensten helpen bedrijven bij het creëren van een sterke visuele identiteit. Van logo-ontwerp tot uitgebreide merkidentiteiten zorgen wij ervoor dat jouw bedrijf zich onderscheidt in een concurrerende markt met consistente en professionele designelementen.",
      "marketing_advertising": "Marketing & Reclame",
      "marketing_advertising_content": "Versnel je groei met onze marketing- en reclameoplossingen. Wij ontwikkelen effectieve marketingstrategieën, beheren digitale advertentiecampagnes en optimaliseren je online aanwezigheid om merkbekendheid te vergroten en gekwalificeerde leads te genereren.",
      "consulting_strategy": "Consultancy & Strategie",
      "consulting_strategy_content": "Onze consultancydiensten bieden bedrijven deskundige begeleiding bij technologie-integratie, digitale transformatie en strategische bedrijfsgroei. We analyseren je huidige processen en adviseren oplossingen die aansluiten bij jouw bedrijfsdoelen.",

      // ContactForm (WorkTogether) component
      "work": "SAMEN",
      "together": "WERKEN",
      "your_name": "JOUW NAAM?",
      "your_company_name": "BEDRIJFSNAAM? (OPTIONEEL)",
      "your_email": "JOUW E-MAIL?",
      "your_mobile_phone": "JOUW MOBIELE TELEFOON?",
      "your_idea": "JOUW IDEE? (OPTIONEEL)",
      "project_budget": "PROJECTBUDGET?",
      "choose_budget": "KIES JE BUDGET",
      "budget_1k_5k": "€1.000 - €5.000",
      "budget_5k_10k": "€5.000 - €10.000",
      "budget_10k_25k": "€10.000 - €25.000",
      "budget_25k_plus": "€25.000+",
      "which_services": "WELKE DIENSTEN HEB JE NODIG?",
      "service_web_development": "WEBONTWIKKELING",
      "service_software_app": "SOFTWARE & APP ONTWIKKELING",
      "service_design_branding": "DESIGN & BRANDING",
      "service_marketing": "MARKETING & RECLAME",
      "service_ai_optimization": "AI & PROCESOPTIMALISATIE",
      "custom_service_placeholder": "Omschrijf je specifieke wensen...",
      "delivery_time": "GEWENSTE LEVERTIJD?",
      "choose_delivery_time": "KIES DE LEVERTIJD",
      "delivery_1_month": "1 Maand",
      "delivery_2_3_months": "2-3 Maanden",
      "delivery_3_6_months": "3-6 Maanden",
      "delivery_6_plus_months": "6+ Maanden",
      "terms_agreement": "IK GA AKKOORD MET DE OPSLAG EN VERWERKING VAN MIJN GEGEVENS.",
      "send_it": "VERSTUREN!",

      // Form validation errors
      "error_name_required": "Naam is verplicht",
      "error_email_required": "E-mail is verplicht",
      "error_phone_required": "Mobiel nummer is verplicht",
      "error_budget_required": "Kies een budget",
      "error_delivery_time_required": "Kies een levertijd",
      "error_service_required": "Selecteer minstens één dienst of geef je wensen op",
      "error_terms_required": "Je moet akkoord gaan met de voorwaarden",
      "form_submit_success": "Formulier succesvol verzonden!",

    // Footer component
      "footer_contact": "CONTACT",
      "footer_address_street": "LIJSTERSTRAAT 112,",
      "footer_address_city": "3815 DN AMERSFOORT",
      "footer_tel": "TEL.",
      "footer_email": "EMAIL.",
      "footer_social": "SOCIAL",
      "footer_instagram": "INSTAGRAM",
      "footer_linkedin": "LINKEDIN",
      "footer_whatsapp": "WHATSAPP",
      "footer_behance": "BEHANCE",
      "footer_services": "DIENSTEN",
      "footer_pages": "PAGINA'S",
      "footer_cases": "CASES",
      "footer_links": "LINKS",
      "footer_link_custom_web": "WEBONTWIKKELING OP MAAT",
      "footer_link_mobile_app": "MOBILE APP LATEN MAKEN",
      "footer_link_web_apps": "WEBAPPLICATIES OP MAAT",
      "footer_link_custom_software": "SOFTWARE OP MAAT ONTWIKKELEN",
      "footer_link_seo": "SEO OPTIMALISATIE",
      "footer_link_digital_marketing": "DIGITALE MARKETING",
      "footer_link_custom_design": "DESIGN & BRANDING OP MAAT",
      "footer_link_saas": "SAAS LATEN ONTWIKKELEN",
      "footer_link_pwa": "PWA LATEN ONTWIKKELEN",
      "footer_link_ecommerce": "E-COMMERCE OP MAAT ONTWIKKELEN",
      "footer_copyright": "© {{year}} ALZIJDIGI B.V. Alle rechten voorbehouden.",
      "footer_privacy_policy": "Privacybeleid",

      // Contact component
      "contact_us": "Neem contact met ons op",
      "get_in_touch": "Neem contact op",
      "contact_description": "Vul het formulier in of neem direct contact op via de onderstaande gegevens. Wij beantwoorden je bericht zo snel mogelijk.",
      "phone": "Telefoon",
      "email": "E-mail",
      "address": "Adres",
      "your_phone": "JOUW TELEFOON?",
      "company_name": "BEDRIJFSNAAM?",
      "your_message": "JOUW BERICHT?",
      "name_required": "Naam is verplicht",
      "email_required": "E-mail is verplicht",
      "valid_email_required": "Voer een geldig e-mailadres in",
      "message_required": "Bericht is verplicht",
      "sending": "Verzenden...",
      "send_message": "Verzend Bericht",
      "thank_you": "Bedankt!",
      "message_sent_successfully": "Je bericht is succesvol verzonden.",
      "send_another_message": "Nog een bericht verzenden",
      "error_message": "Er is iets misgegaan bij het verzenden van je bericht. Probeer het opnieuw.",
      "contact_page_description": "Wij horen graag van je. Kies de manier die het beste bij je past om contact op te nemen.",
"request_callback": "Terugbelverzoek",
"phone_required": "Telefoonnummer is verplicht",
"time_required": "Kies een geschikt tijdstip",
"best_time_to_call": "Geschikt tijdstip om te bellen",
"select_time": "Kies een tijdstip",
"morning": "Ochtend",
"afternoon": "Middag",
"evening": "Avond",
"contact_success": "We hebben je bericht ontvangen en nemen spoedig contact met je op.",
"continue": "Doorgaan",
"chat_with_us": "Chat met ons",
"chat_with_our_bot": "Chat met onze assistent",
"chat_description": "Stel je vragen en krijg direct antwoord van onze chatbot.",
"start_chat": "Start chat",

      // About page translations
      about_us: "Over AlzijDigi",
      about_description: "AlzijDigi is een vooruitstrevend digitaal bureau gevestigd in Nederland, gespecialiseerd in het creëren van innovatieve softwareoplossingen die bedrijfsgroei stimuleren. Met ons team van ervaren ontwikkelaars, ontwerpers en digitale strategen helpen we bedrijven hun digitale aanwezigheid te transformeren en hun doelen te bereiken door middel van geavanceerde technologie en creatieve oplossingen.",
      our_mission: "Onze Missie",
      mission_description: "Onze missie is om bedrijven te empoweren met technologie die het verschil maakt. Wij geloven in het creëren van digitale oplossingen die niet alleen technisch solide zijn, maar ook echte bedrijfswaarde opleveren. We combineren technische expertise met creatieve innovatie om uitzonderlijke digitale ervaringen te leveren die onze klanten helpen slagen in het digitale tijdperk.",
      our_team: "Ons Team",
      team_description: "Ons team bestaat uit gepassioneerde professionals die experts zijn in hun respectievelijke vakgebieden. Van softwareontwikkelaars en UX-ontwerpers tot digitale strategen en projectmanagers, we brengen diverse vaardigheden en perspectieven samen om uitgebreide digitale oplossingen te leveren. We zijn toegewijd aan continu leren en blijven voorop lopen in technologische innovatie.",
      
      // 404 page translations
      page_not_found: "Pagina Niet Gevonden",
      page_not_found_description: "De pagina die u zoekt bestaat niet of is verplaatst. Maak gebruik van de onderstaande links om terug te navigeren of ontdek onze diensten.",
      back_to_home: "Terug naar Home",
      view_services: "Bekijk Diensten",
      explore_services: "Ontdek Diensten",
      learn_more: "Meer Informatie",
      contact_us_404: "Neem Contact Op",
      services_help_text: "Bekijk onze uitgebreide digitale diensten en oplossingen.",
      about_help_text: "Leer meer over ons team en onze missie.",
      contact_help_text: "Neem direct contact met ons op voor uw project.",

      // Service pages translations
      "service_features": "Kenmerken",
      "service_benefits": "Voordelen",
      
      // Web Development Service
      "service_webontwikkeling_title": "Webontwikkeling",
      "service_webontwikkeling_description": "Professionele webontwikkeling op maat voor uw bedrijf. Wij bouwen moderne, snelle en gebruiksvriendelijke websites die uw online aanwezigheid versterken.",
      "service_webontwikkeling_feature_1": "Responsive design voor alle apparaten",
      "service_webontwikkeling_feature_2": "Moderne technologieën en frameworks",
      "service_webontwikkeling_feature_3": "SEO-vriendelijke structuur",
      "service_webontwikkeling_feature_4": "Snelle laadtijden en optimale prestaties",
      "service_webontwikkeling_benefit_1": "Verbeterde gebruikerservaring",
      "service_webontwikkeling_benefit_2": "Betere vindbaarheid in zoekmachines",
      "service_webontwikkeling_benefit_3": "Hogere conversieratio's",
      "service_webontwikkeling_benefit_4": "Toekomstbestendige oplossingen",

      // Mobile App Service
      "service_mobiele-app_title": "Mobiele App Ontwikkeling",
      "service_mobiele-app_description": "Native en cross-platform mobiele applicaties die uw bedrijf naar het volgende niveau tillen. Wij ontwikkelen apps die gebruikers raken en resultaten leveren.",
      "service_mobiele-app_feature_1": "Native iOS en Android ontwikkeling",
      "service_mobiele-app_feature_2": "Cross-platform oplossingen",
      "service_mobiele-app_feature_3": "Offline functionaliteit",
      "service_mobiele-app_feature_4": "Push-notificaties",
      "service_mobiele-app_benefit_1": "Bereik meer gebruikers",
      "service_mobiele-app_benefit_2": "Verbeterde klantbetrokkenheid",
      "service_mobiele-app_benefit_3": "Efficiëntere bedrijfsprocessen",
      "service_mobiele-app_benefit_4": "Competitief voordeel",

      // Custom Software Service
      "service_maatwerk-software_title": "Maatwerk Software",
      "service_maatwerk-software_description": "Op maat gemaakte softwareoplossingen die perfect aansluiten bij uw bedrijfsprocessen. Wij ontwikkelen software die uw efficiëntie verhoogt en kosten bespaart.",
      "service_maatwerk-software_feature_1": "Op maat gemaakte functionaliteit",
      "service_maatwerk-software_feature_2": "Integratie met bestaande systemen",
      "service_maatwerk-software_feature_3": "Schaalbare architectuur",
      "service_maatwerk-software_feature_4": "Uitgebreide documentatie",
      "service_maatwerk-software_benefit_1": "Geoptimaliseerde workflows",
      "service_maatwerk-software_benefit_2": "Kostenefficiëntie",
      "service_maatwerk-software_benefit_3": "Betere data-analyse",
      "service_maatwerk-software_benefit_4": "Toekomstbestendige oplossingen",

      // Digital Marketing Service
      "service_digitale-marketing_title": "Digitale Marketing",
      "service_digitale-marketing_description": "Effectieve digitale marketingstrategieën die uw online aanwezigheid versterken en uw bedrijf laten groeien. Wij helpen u uw doelgroep te bereiken en te converteren.",
      "service_digitale-marketing_feature_1": "SEO optimalisatie",
      "service_digitale-marketing_feature_2": "Social media marketing",
      "service_digitale-marketing_feature_3": "Content marketing",
      "service_digitale-marketing_feature_4": "E-mail marketing",
      "service_digitale-marketing_benefit_1": "Verhoogde online zichtbaarheid",
      "service_digitale-marketing_benefit_2": "Meer kwalitatieve leads",
      "service_digitale-marketing_benefit_3": "Betere ROI",
      "service_digitale-marketing_benefit_4": "Data-gedreven besluitvorming",

      // Additional Service Pages
      "service_maatwerk-web_title": "Custom Web Development",
      "service_maatwerk-web_description": "Custom-made websites that perfectly match your business needs. We develop websites that strengthen your online presence and achieve your goals.",
      "service_maatwerk-web_feature_1": "Custom design and development",
      "service_maatwerk-web_feature_2": "Responsive and mobile-friendly",
      "service_maatwerk-web_feature_3": "Content Management System",
      "service_maatwerk-web_feature_4": "SEO optimization",
      "service_maatwerk-web_benefit_1": "Unique online identity",
      "service_maatwerk-web_benefit_2": "Better user experience",
      "service_maatwerk-web_benefit_3": "Easy to manage",
      "service_maatwerk-web_benefit_4": "Improved visibility",

      "service_web-apps_title": "Custom Web Applications",
      "service_web-apps_description": "Powerful web applications that streamline and automate your business processes. We develop applications that increase your efficiency and save costs.",
      "service_web-apps_feature_1": "Custom functionality",
      "service_web-apps_feature_2": "Real-time updates",
      "service_web-apps_feature_3": "Database integration",
      "service_web-apps_feature_4": "API integration",
      "service_web-apps_benefit_1": "Automated processes",
      "service_web-apps_benefit_2": "Improved productivity",
      "service_web-apps_benefit_3": "Better data analysis",
      "service_web-apps_benefit_4": "Scalable solutions",

      "service_seo_title": "SEO Optimization",
      "service_seo_description": "Improve your online visibility and reach more potential customers with our SEO services. We optimize your website for search engines and help you rank higher.",
      "service_seo_feature_1": "Technical SEO audit",
      "service_seo_feature_2": "Keyword research",
      "service_seo_feature_3": "On-page optimization",
      "service_seo_feature_4": "Content optimization",
      "service_seo_benefit_1": "Higher search rankings",
      "service_seo_benefit_2": "More organic traffic",
      "service_seo_benefit_3": "Better conversion rates",
      "service_seo_benefit_4": "Long-lasting results",

      "service_maatwerk-design_title": "Custom Design & Branding",
      "service_maatwerk-design_description": "Create a strong visual identity that sets your business apart. We develop unique designs that strengthen your brand and appeal to your target audience.",
      "service_maatwerk-design_feature_1": "Logo design",
      "service_maatwerk-design_feature_2": "Brand identity",
      "service_maatwerk-design_feature_3": "UI/UX design",
      "service_maatwerk-design_feature_4": "Print materials",
      "service_maatwerk-design_benefit_1": "Strong brand identity",
      "service_maatwerk-design_benefit_2": "Consistent appearance",
      "service_maatwerk-design_benefit_3": "Professional look",
      "service_maatwerk-design_benefit_4": "Increased recognition",

      "service_saas_title": "SaaS Development",
      "service_saas_description": "Develop your own Software-as-a-Service platform with our expertise. We help you build a scalable and profitable SaaS solution.",
      "service_saas_feature_1": "Multi-tenant architecture",
      "service_saas_feature_2": "Subscription management",
      "service_saas_feature_3": "API development",
      "service_saas_feature_4": "Cloud integration",
      "service_saas_benefit_1": "Recurring revenue",
      "service_saas_benefit_2": "Scalable solution",
      "service_saas_benefit_3": "Low operational costs",
      "service_saas_benefit_4": "Widespread accessibility",

      "service_pwa_title": "Progressive Web Apps",
      "service_pwa_description": "Combine the best features of websites and mobile apps with a Progressive Web App. We develop fast, reliable, and engaging web applications.",
      "service_pwa_feature_1": "Offline functionality",
      "service_pwa_feature_2": "Push notifications",
      "service_pwa_feature_3": "App-like experience",
      "service_pwa_feature_4": "Fast loading times",
      "service_pwa_benefit_1": "Improved user experience",
      "service_pwa_benefit_2": "Low development costs",
      "service_pwa_benefit_3": "Easy to maintain",
      "service_pwa_benefit_4": "Better performance",

      "service_ecommerce_title": "E-commerce Development",
      "service_ecommerce_description": "Build a powerful online store that drives sales and attracts customers. We develop e-commerce platforms that optimize your online sales.",
      "service_ecommerce_feature_1": "Product management",
      "service_ecommerce_feature_2": "Payment gateway integration",
      "service_ecommerce_feature_3": "Order management",
      "service_ecommerce_feature_4": "Customer accounts",
      "service_ecommerce_benefit_1": "Increased online sales",
      "service_ecommerce_benefit_2": "Improved customer experience",
      "service_ecommerce_benefit_3": "Efficient order management",
      "service_ecommerce_benefit_4": "Scalable solution",

      // Cases page translations
      "cases_title": "Onze Cases",
      "cases_coming_soon": "Binnenkort vindt u hier onze meest recente projecten en succesverhalen. We zijn momenteel bezig met het voorbereiden van inspirerende cases die laten zien hoe we bedrijven helpen groeien.",
      "case_1_title": "Coming Soon",
      "case_1_description": "Binnenkort beschikbaar",
      "case_2_title": "Coming Soon",
      "case_2_description": "Binnenkort beschikbaar",
      "case_3_title": "Coming Soon",
      "case_3_description": "Binnenkort beschikbaar",
      "tech_web": "Web",
      "tech_mobile": "Mobiel",
      "tech_design": "Design",

      // Privacy page translations
      "privacy_title": "Privacybeleid",
      "privacy_section_1_title": "Inleiding",
      "privacy_section_1_content": "AlzijDigi respecteert uw privacy en zorgt ervoor dat alle persoonlijke informatie die u ons verschaft vertrouwelijk blijft. Dit privacybeleid beschrijft hoe wij omgaan met uw persoonlijke gegevens.",
      "privacy_section_2_title": "Verzameling van Gegevens",
      "privacy_section_2_content": "Wij verzamelen alleen gegevens die noodzakelijk zijn voor het verlenen van onze diensten. Dit kunnen zijn: naam, e-mailadres, telefoonnummer en bedrijfsgegevens.",
      "privacy_section_3_title": "Gebruik van Gegevens",
      "privacy_section_3_content": "Uw gegevens worden uitsluitend gebruikt voor het verlenen van onze diensten, het verbeteren van onze dienstverlening en het communiceren met u over onze diensten.",

      // Service detail pages translations
      "web_development_detail_content": "Onze webontwikkelingsdiensten zijn ontworpen om krachtige, schaalbare en gebruiksvriendelijke websites te creëren die bedrijven helpen een sterke online aanwezigheid op te bouwen. Wij zijn gespecialiseerd in het bouwen van maatwerk websites, e-commerce platforms en webapplicaties met behulp van de nieuwste technologieën en beste praktijken. Ons team zorgt ervoor dat elke website die wij ontwikkelen geoptimaliseerd is voor prestaties, veiligheid en zoekmachines.",
      
      "software_app_development_detail_content": "Wij creëren maatwerk software-oplossingen en mobiele applicaties die bedrijfsprocessen stroomlijnen en de gebruikerservaring verbeteren. Ons ontwikkelteam gebruikt geavanceerde technologieën om robuuste, schaalbare en veilige applicaties te bouwen die aansluiten bij uw specifieke bedrijfsbehoeften. Van concept tot implementatie zorgen wij voor kwaliteit en betrouwbaarheid in elke fase.",
      
      "design_branding_detail_content": "Onze design- en brandingdiensten helpen bedrijven een onderscheidende visuele identiteit te creëren die aanspreekt bij hun doelgroep. Wij combineren creativiteit met strategisch denken om overtuigende merkidentiteiten, boeiende gebruikersinterfaces en memorabele visuele ervaringen te ontwikkelen die u onderscheiden van concurrenten.",
      
      "marketing_advertising_detail_content": "Onze marketing- en reclamediensten zijn ontworpen om bedrijven te helpen hun doelgroep te bereiken en hun groeidoelstellingen te behalen. Wij ontwikkelen uitgebreide digitale marketingstrategieën, beheren advertentiecampagnes en optimaliseren uw online aanwezigheid om de merkbekendheid te vergroten en conversies te stimuleren.",
      
      "consulting_strategy_detail_content": "Onze consultancydiensten bieden deskundige begeleiding bij technologie-integratie, digitale transformatie en strategische bedrijfsgroei. Wij analyseren uw huidige processen, identificeren verbeterpunten en ontwikkelen op maat gemaakte oplossingen die aansluiten bij uw bedrijfsdoelen en duurzame groei stimuleren."
    }
  },
  en: {
    translation: {
      // Home component
      "collaborate_create": "Let's Collaborate & Create Something Amazing",
      "build_description": "We build high-performance software that helps businesses scale, innovate, and stay ahead. Whether it's custom applications, SaaS platforms, or AI-driven solutions, we craft technology that is efficient, modern, and built for the future.",
      "see_difference": "See how we make a difference",
      "view_cases": "View Cases",
      
      // Header component
      "home": "HOME",
      "about": "ABOUT",
      "services": "SERVICES",
      "contact": "CONTACT",
      "lets_call": "LET'S CALL",
      
      // Services component
      "read_more": "Read more",
      "our_services": "Our Services",
      "services_subtitle": "Discover our comprehensive digital services and solutions",
      "web_development": "Web Development",
      "web_development_content": "Our web development services include building websites from scratch, customizing various CMS systems, developing web applications, and providing post-launch support. We always work with the latest technologies to create fast, feature-rich, and attractive websites.",
      "software_app_development": "Software & App Development",
      "software_app_development_content": "We specialize in developing custom software and mobile apps that help businesses streamline processes and effectively reach their target audience. Our development team masters various programming languages and frameworks to deliver robust and scalable applications.",
      "design_branding": "Design & Branding",
      "design_branding_content": "Our design and branding services help businesses create a strong visual identity. From logo design to comprehensive brand identities, we ensure your business stands out in a competitive market with consistent and professional design elements.",
      "marketing_advertising": "Marketing & Advertising",
      "marketing_advertising_content": "Accelerate your growth with our marketing and advertising solutions. We develop effective marketing strategies, manage digital advertising campaigns, and optimize your online presence to increase brand awareness and generate qualified leads.",
      "consulting_strategy": "CONSULTING & STRATEGY",
      "consulting_strategy_content": "Our consulting services provide businesses with expert guidance on technology integration, digital transformation, and strategic business growth. We analyze your current processes and advise solutions that align with your business goals.",
      
      // ContactForm (WorkTogether) component
      "work": "WORK",
      "together": "TOGETHER",
      "your_name": "YOUR NAME?",
      "your_company_name": "YOUR COMPANY'S NAME? (OPTIONAL)",
      "your_email": "YOUR EMAIL?",
      "your_mobile_phone": "YOUR MOBILE PHONE?",
      "your_idea": "YOUR IDEA? (OPTIONAL)",
      "project_budget": "PROJECT BUDGET?",
      "choose_budget": "CHOOSE YOUR BUDGET",
      "budget_1k_5k": "€1,000 - €5,000",
      "budget_5k_10k": "€5,000 - €10,000",
      "budget_10k_25k": "€10,000 - €25,000",
      "budget_25k_plus": "€25,000+",
      "which_services": "WHICH SERVICES DO YOU NEED?",
      "service_web_development": "WEB DEVELOPMENT",
      "service_software_app": "SOFTWARE & APP DEVELOPMENT",
      "service_design_branding": "DESIGN & BRANDING",
      "service_marketing": "MARKETING & ADVERTISING",
      "service_ai_optimization": "AI & PROCESS OPTIMIZATION",
      "custom_service_placeholder": "Describe your specific service needs...",
      "delivery_time": "DESIRED DELIVERY TIME?",
      "choose_delivery_time": "CHOOSE YOUR DESIRED DELIVERY TIME",
      "delivery_1_month": "1 Month",
      "delivery_2_3_months": "2-3 Months",
      "delivery_3_6_months": "3-6 Months",
      "delivery_6_plus_months": "6+ Months",
      "terms_agreement": "I AGREE TO THE STORAGE AND PROCESSING OF MY DATA.",
      "send_it": "SEND IT!",
      
      // Form validation errors
      "error_name_required": "Your name is required",
      "error_email_required": "Email is required",
      "error_phone_required": "Mobile phone is required",
      "error_budget_required": "Please select a budget",
      "error_delivery_time_required": "Please select a delivery time",
      "error_service_required": "Please select at least one service or describe your custom needs",
      "error_terms_required": "You must agree to the terms",
      "form_submit_success": "Form submitted successfully!",

       // Footer component
      "footer_contact": "CONTACT",
      "footer_address_street": "LIJSTERSTRAAT 112,",
      "footer_address_city": "3815 DN AMERSFOORT",
      "footer_tel": "TEL.",
      "footer_email": "EMAIL.",
      "footer_social": "SOCIAL",
      "footer_instagram": "INSTAGRAM",
      "footer_linkedin": "LINKEDIN",
      "footer_whatsapp": "WHATSAPP",
      "footer_behance": "BEHANCE",
      "footer_services": "SERVICES",
      "footer_pages": "PAGES",
      "footer_cases": "CASES",
      "footer_links": "LINKS",
      "footer_link_custom_web": "CUSTOM WEB DEVELOPMENT",
      "footer_link_mobile_app": "MOBILE APP DEVELOPMENT",
      "footer_link_web_apps": "CUSTOM WEB APPLICATIONS",
      "footer_link_custom_software": "CUSTOM SOFTWARE DEVELOPMENT",
      "footer_link_seo": "SEO OPTIMIZATION",
      "footer_link_digital_marketing": "DIGITAL MARKETING",
      "footer_link_custom_design": "CUSTOM DESIGN & BRANDING",
      "footer_link_saas": "SAAS DEVELOPMENT",
      "footer_link_pwa": "PWA DEVELOPMENT",
      "footer_link_ecommerce": "CUSTOM E-COMMERCE DEVELOPMENT",
      "footer_copyright": "© {{year}} ALZIJDIGI B.V. All rights reserved.",
      "footer_privacy_policy": "Privacy Policy",

      // Thank you message
      "thank_you_heading": "Thank You!",
      "thank_you_message": "We've received your message and will get back to you as soon as possible.",
      "close": "Close",
      
      // Error message
      "error_heading": "Oops!",
      "try_again": "Try Again",

      // Contact component
      "contact_us": "Contact Us",
      "contact_description": "Fill in the form or reach out directly via the details below. We'll respond to your message as soon as possible.",
      "phone": "Phone",
      "email": "Email",
      "address": "Address",
      "your_phone": "YOUR PHONE?",
      "company_name": "COMPANY NAME?",
      "your_message": "YOUR MESSAGE?",
      "name_required": "Name is required",
      "email_required": "Email is required",
      "valid_email_required": "Please enter a valid email address",
      "message_required": "Message is required",
      "send_message": "Send Message",
      "thank_you": "Thank You!",
      "message_sent_successfully": "Your message was successfully sent.",
      "send_another_message": "Send Another Message",
      "contact_page_description": "We'd love to hear from you. Choose the contact method that suits you best.",
"request_callback": "Request Callback",
"phone_required": "Phone number is required",
"time_required": "Please select a suitable time",
"best_time_to_call": "Best Time to Call",
"select_time": "Select a time",
"morning": "Morning",
"afternoon": "Afternoon",
"evening": "Evening",
"contact_success": "We've received your message and will get back to you soon.",
"continue": "Continue",
"chat_with_us": "Chat with Us",
"chat_with_our_bot": "Chat with Our Assistant",
"chat_description": "Ask your questions and get instant answers from our chatbot.",
"start_chat": "Start Chat",

      // About page translations
      about_us: "About AlzijDigi",
      about_description: "AlzijDigi is a forward-thinking digital agency based in the Netherlands, specializing in creating innovative software solutions that drive business growth. With our team of expert developers, designers, and digital strategists, we help businesses transform their digital presence and achieve their goals through cutting-edge technology and creative solutions.",
      our_mission: "Our Mission",
      mission_description: "Our mission is to empower businesses with technology that makes a difference. We believe in creating digital solutions that are not just technically sound, but also drive real business value. We combine technical expertise with creative innovation to deliver exceptional digital experiences that help our clients succeed in the digital age.",
      our_team: "Our Team",
      team_description: "Our team consists of passionate professionals who are experts in their respective fields. From software developers and UX designers to digital strategists and project managers, we bring together diverse skills and perspectives to deliver comprehensive digital solutions. We are committed to continuous learning and staying at the forefront of technological innovation.",
      
      // 404 page translations
      page_not_found: "Page Not Found",
      page_not_found_description: "The page you're looking for doesn't exist or has been moved. Use the links below to navigate back or discover our services.",
      back_to_home: "Back to Home",
      view_services: "View Services",
      explore_services: "Explore Services",
      learn_more: "Learn More",
      contact_us_404: "Get in Touch",
      services_help_text: "Discover our comprehensive digital services and solutions.",
      about_help_text: "Learn more about our team and our mission.",
      contact_help_text: "Reach out directly to us for your project.",

      // Service pages translations
      "service_features": "Features",
      "service_benefits": "Benefits",
      
      // Web Development Service
      "service_webontwikkeling_title": "Web Development",
      "service_webontwikkeling_description": "Professional custom web development for your business. We build modern, fast, and user-friendly websites that strengthen your online presence.",
      "service_webontwikkeling_feature_1": "Responsive design for all devices",
      "service_webontwikkeling_feature_2": "Modern technologies and frameworks",
      "service_webontwikkeling_feature_3": "SEO-friendly structure",
      "service_webontwikkeling_feature_4": "Fast loading times and optimal performance",
      "service_webontwikkeling_benefit_1": "Enhanced user experience",
      "service_webontwikkeling_benefit_2": "Better search engine visibility",
      "service_webontwikkeling_benefit_3": "Higher conversion rates",
      "service_webontwikkeling_benefit_4": "Future-proof solutions",

      // Mobile App Service
      "service_mobiele-app_title": "Mobile App Development",
      "service_mobiele-app_description": "Native and cross-platform mobile applications that take your business to the next level. We develop apps that engage users and deliver results.",
      "service_mobiele-app_feature_1": "Native iOS and Android development",
      "service_mobiele-app_feature_2": "Cross-platform solutions",
      "service_mobiele-app_feature_3": "Offline functionality",
      "service_mobiele-app_feature_4": "Push notifications",
      "service_mobiele-app_benefit_1": "Reach more users",
      "service_mobiele-app_benefit_2": "Improved customer engagement",
      "service_mobiele-app_benefit_3": "More efficient business processes",
      "service_mobiele-app_benefit_4": "Competitive advantage",

      // Custom Software Service
      "service_maatwerk-software_title": "Custom Software",
      "service_maatwerk-software_description": "Tailored software solutions that perfectly match your business processes. We develop software that increases your efficiency and saves costs.",
      "service_maatwerk-software_feature_1": "Custom functionality",
      "service_maatwerk-software_feature_2": "Integration with existing systems",
      "service_maatwerk-software_feature_3": "Scalable architecture",
      "service_maatwerk-software_feature_4": "Comprehensive documentation",
      "service_maatwerk-software_benefit_1": "Optimized workflows",
      "service_maatwerk-software_benefit_2": "Cost efficiency",
      "service_maatwerk-software_benefit_3": "Better data analysis",
      "service_maatwerk-software_benefit_4": "Future-proof solutions",

      // Digital Marketing Service
      "service_digitale-marketing_title": "Digital Marketing",
      "service_digitale-marketing_description": "Effective digital marketing strategies that strengthen your online presence and grow your business. We help you reach and convert your target audience.",
      "service_digitale-marketing_feature_1": "SEO optimization",
      "service_digitale-marketing_feature_2": "Social media marketing",
      "service_digitale-marketing_feature_3": "Content marketing",
      "service_digitale-marketing_feature_4": "Email marketing",
      "service_digitale-marketing_benefit_1": "Increased online visibility",
      "service_digitale-marketing_benefit_2": "More qualified leads",
      "service_digitale-marketing_benefit_3": "Better ROI",
      "service_digitale-marketing_benefit_4": "Data-driven decision making",

      // Additional Service Pages
      "service_maatwerk-web_title": "Custom Web Development",
      "service_maatwerk-web_description": "Custom-made websites that perfectly match your business needs. We develop websites that strengthen your online presence and achieve your goals.",
      "service_maatwerk-web_feature_1": "Custom design and development",
      "service_maatwerk-web_feature_2": "Responsive and mobile-friendly",
      "service_maatwerk-web_feature_3": "Content Management System",
      "service_maatwerk-web_feature_4": "SEO optimization",
      "service_maatwerk-web_benefit_1": "Unique online identity",
      "service_maatwerk-web_benefit_2": "Better user experience",
      "service_maatwerk-web_benefit_3": "Easy to manage",
      "service_maatwerk-web_benefit_4": "Improved visibility",

      "service_web-apps_title": "Custom Web Applications",
      "service_web-apps_description": "Powerful web applications that streamline and automate your business processes. We develop applications that increase your efficiency and save costs.",
      "service_web-apps_feature_1": "Custom functionality",
      "service_web-apps_feature_2": "Real-time updates",
      "service_web-apps_feature_3": "Database integration",
      "service_web-apps_feature_4": "API integration",
      "service_web-apps_benefit_1": "Automated processes",
      "service_web-apps_benefit_2": "Improved productivity",
      "service_web-apps_benefit_3": "Better data analysis",
      "service_web-apps_benefit_4": "Scalable solutions",

      "service_seo_title": "SEO Optimization",
      "service_seo_description": "Improve your online visibility and reach more potential customers with our SEO services. We optimize your website for search engines and help you rank higher.",
      "service_seo_feature_1": "Technical SEO audit",
      "service_seo_feature_2": "Keyword research",
      "service_seo_feature_3": "On-page optimization",
      "service_seo_feature_4": "Content optimization",
      "service_seo_benefit_1": "Higher search rankings",
      "service_seo_benefit_2": "More organic traffic",
      "service_seo_benefit_3": "Better conversion rates",
      "service_seo_benefit_4": "Long-lasting results",

      "service_maatwerk-design_title": "Custom Design & Branding",
      "service_maatwerk-design_description": "Create a strong visual identity that sets your business apart. We develop unique designs that strengthen your brand and appeal to your target audience.",
      "service_maatwerk-design_feature_1": "Logo design",
      "service_maatwerk-design_feature_2": "Brand identity",
      "service_maatwerk-design_feature_3": "UI/UX design",
      "service_maatwerk-design_feature_4": "Print materials",
      "service_maatwerk-design_benefit_1": "Strong brand identity",
      "service_maatwerk-design_benefit_2": "Consistent appearance",
      "service_maatwerk-design_benefit_3": "Professional look",
      "service_maatwerk-design_benefit_4": "Increased recognition",

      "service_saas_title": "SaaS Development",
      "service_saas_description": "Develop your own Software-as-a-Service platform with our expertise. We help you build a scalable and profitable SaaS solution.",
      "service_saas_feature_1": "Multi-tenant architecture",
      "service_saas_feature_2": "Subscription management",
      "service_saas_feature_3": "API development",
      "service_saas_feature_4": "Cloud integration",
      "service_saas_benefit_1": "Recurring revenue",
      "service_saas_benefit_2": "Scalable solution",
      "service_saas_benefit_3": "Low operational costs",
      "service_saas_benefit_4": "Widespread accessibility",

      "service_pwa_title": "Progressive Web Apps",
      "service_pwa_description": "Combine the best features of websites and mobile apps with a Progressive Web App. We develop fast, reliable, and engaging web applications.",
      "service_pwa_feature_1": "Offline functionality",
      "service_pwa_feature_2": "Push notifications",
      "service_pwa_feature_3": "App-like experience",
      "service_pwa_feature_4": "Fast loading times",
      "service_pwa_benefit_1": "Improved user experience",
      "service_pwa_benefit_2": "Low development costs",
      "service_pwa_benefit_3": "Easy to maintain",
      "service_pwa_benefit_4": "Better performance",

      "service_ecommerce_title": "E-commerce Development",
      "service_ecommerce_description": "Build a powerful online store that drives sales and attracts customers. We develop e-commerce platforms that optimize your online sales.",
      "service_ecommerce_feature_1": "Product management",
      "service_ecommerce_feature_2": "Payment gateway integration",
      "service_ecommerce_feature_3": "Order management",
      "service_ecommerce_feature_4": "Customer accounts",
      "service_ecommerce_benefit_1": "Increased online sales",
      "service_ecommerce_benefit_2": "Improved customer experience",
      "service_ecommerce_benefit_3": "Efficient order management",
      "service_ecommerce_benefit_4": "Scalable solution",

      // Cases page translations
      "cases_title": "Our Cases",
      "cases_coming_soon": "Coming soon you will find our most recent projects and success stories here. We are currently preparing inspiring cases that show how we help businesses grow.",
      "case_1_title": "Coming Soon",
      "case_1_description": "Available soon",
      "case_2_title": "Coming Soon",
      "case_2_description": "Available soon",
      "case_3_title": "Coming Soon",
      "case_3_description": "Available soon",
      "tech_web": "Web",
      "tech_mobile": "Mobile",
      "tech_design": "Design",

      // Privacy page translations
      "privacy_title": "Privacy Policy",
      "privacy_section_1_title": "Introduction",
      "privacy_section_1_content": "AlzijDigi respects your privacy and ensures that all personal information you provide to us remains confidential. This privacy policy describes how we handle your personal data.",
      "privacy_section_2_title": "Data Collection",
      "privacy_section_2_content": "We only collect data that is necessary for providing our services. This may include: name, email address, phone number, and company information.",
      "privacy_section_3_title": "Use of Data",
      "privacy_section_3_content": "Your data is used exclusively for providing our services, improving our service delivery, and communicating with you about our services.",

      // Service detail pages translations
      "web_development_detail_content": "Our web development services are designed to create powerful, scalable, and user-friendly websites that help businesses establish a strong online presence. We specialize in building custom websites, e-commerce platforms, and web applications using the latest technologies and best practices. Our team ensures that every website we develop is optimized for performance, security, and search engines.",
      
      "software_app_development_detail_content": "We create custom software solutions and mobile applications that streamline business processes and enhance user experience. Our development team uses cutting-edge technologies to build robust, scalable, and secure applications that meet your specific business needs. From concept to deployment, we ensure quality and reliability at every step.",
      
      "design_branding_detail_content": "Our design and branding services help businesses create a distinctive visual identity that resonates with their target audience. We combine creativity with strategic thinking to develop compelling brand identities, engaging user interfaces, and memorable visual experiences that set you apart from competitors.",
      
      "marketing_advertising_detail_content": "Our marketing and advertising services are designed to help businesses reach their target audience and achieve their growth objectives. We develop comprehensive digital marketing strategies, manage advertising campaigns, and optimize your online presence to increase brand awareness and drive conversions.",
      
      "consulting_strategy_detail_content": "Our consulting services provide expert guidance on technology integration, digital transformation, and strategic business growth. We analyze your current processes, identify opportunities for improvement, and develop tailored solutions that align with your business goals and drive sustainable growth."
    }
  }
};
// Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'nl', // Default language is Dutch
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // React already escapes values
    }
  });

// Language provider component
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(i18n.language || 'nl');

  // Function to change language
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setLanguage(lng);
  };

  // Update state when language changes
  useEffect(() => {
    const handleLanguageChanged = () => {
      setLanguage(i18n.language);
    };

    i18n.on('languageChanged', handleLanguageChanged);
    
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, []);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook to use the language context
export const useLanguage = () => useContext(LanguageContext);

export default i18n;